export default {
    PRIMARY_BLUE: "rgba(70, 84, 249, 1)",
    YELLOW: "#d79b32",
    DARK: "#212121",
    MAIN_BACKGROUND: "#191B20",
    SECONDARY_BACKGROUND_COLOUR: "#282C34",
    GREY: '#8c8c8c'
}